<div class="custom-scrollbar-css">
    <h2 class="modal-title  "> Communication</h2>
  
    <div class="row mx-0 px-0 "  >
        <div class="col-12 col-md-12  ">
            <h1 class="p-2">
                <img src="https://img.icons8.com/dusk/30/000000/settings.png" />

                Propriétés</h1>
            <div>
                <mat-checkbox class="example-margin" [(ngModel)]="checked">Activer le bufering</mat-checkbox>
            </div>

        </div>
     
        <div class="col-6 col-md-6  ">
            <h1 class="p-2">
                <img src="https://img.icons8.com/officel/30/000000/command-line.png" />

                Commande</h1>

            <div>
                <mat-form-field [formGroup]="registerForm"  (submit)="submitFormCommunication()"  appearance="fill" class="mb-3">
                    <mat-label>Commande</mat-label>
                    <mat-select formControlName="commandType"    >
                        <mat-option></mat-option>
                        <mat-option (click)="getValueSelect(option.value)"    [(value)]="option.value" *ngFor="let option of commandLine">{{ option.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div  [formGroup]="registerForm" (submit)="submitFormCommunication()" *ngIf="command == 18" aria-label="Select an option">  
                    <input type="radio"  formControlName="action"  value="0" /> DELETE UNSENT CSA EVENTS  <br>
                    <input type="radio"  formControlName="action"  value="1" /> DELETE ALL FILES OTHER THAN EDR FILES <br>
                </div>

                <div [formGroup]="registerForm"   *ngIf="command == 56" aria-label="Select an option">  
                    <input type="radio"  formControlName="action"  value="0"  /> PRIVATE  <br>
                    <input type="radio"  formControlName="action"  value="1" /> LARGE VAN <br>
                    <input type="radio"  formControlName="action"  value="2" /> LIGHT TRUCK <br>
                    <input type="radio"  formControlName="action"  value="3" /> HEAVY TRUCK <br>
                </div>

                <div   [formGroup]="registerForm"  *ngIf="command == 20" >  
                    <input type="radio"  formControlName="action"    value="0" /> REQUEST CALIBRATION STATUS  <br>
                    <input type="radio" formControlName="action"    value="1" /> LEAVE CALIBRATED MODE <br>
                    <input type="radio"  formControlName="action"    value="2" /> ENTER CALIBRATED MODE <br>

                </div>
            </div>
        </div>

 
 
        <div class="col-6 col-md-6 w-100">
            <h1 class="p-2">
                <img src="https://img.icons8.com/fluent/30/000000/sandbox.png" />
                Programmation</h1>
                <main id="container">
                    <div id="terminal">
                      <!-- Terminal Bar -->       
                      <section id="terminal__bar">          
                        <div id="bar__buttons">            
                          <button class="bar__button" id="bar__button--exit">&#10005;</button>            
                          <button class="bar__button">&#9472;</button>                
                          <button class="bar__button">&#9723;</button>          
                        </div>          
                        <p id="bar__user">STG@DRIVE: ~</p>        
                      </section>        
                      <!-- Terminal Body -->        
                      <section id="terminal__body">          
                        <div id="terminal__prompt">            
                          <span id="terminal__prompt--user">STG@DRIVE:</span>            
                          <span id="terminal__prompt--location">~</span>            
                          <span id="terminal__prompt--bling">#</span>            
                             
                          <input style="
                          background-color: transparent;
                          border: none;color:white
                      " type="email"   id="exampleFormControlInput1" >    
                          
                        </div>        
                      </section>      
                    </div>    
                  </main>

        </div>
   
    </div>
 
</div>

<div class=" justify-content-center d-flex mt-5 mb-1">
    <a class="btn text-uppercase mr-2" type="submit" [ngClass]="{'disabled': !registerForm.valid }"   (click)="submitFormCommunication()"  >Envoyer</a>

          <a class="btn text-uppercase" type="submit" aria-pressed="true" (click)="onNoClick()" >Annuler</a>
</div>

